export const bentoGridStyles = {
  root: 'grid grid-cols-1 gap-3 sm:grid-cols-2 sm:gap-4 lg:grid-cols-4 lg:gap-4',
} as const;

export const bentoTileStyles = {
  root: 'group relative flex flex-col justify-end overflow-hidden rounded-lg border border-brand-700/20 p-4 min-h-[140px] transition-shadow hover:shadow-md',
  size: {
    small: 'sm:col-span-1 lg:col-span-1 min-h-[140px]',
    medium: 'sm:col-span-1 lg:col-span-2 min-h-[160px]',
    wide: 'sm:col-span-2 lg:col-span-2 min-h-[160px]',
    tall: 'sm:col-span-1 lg:col-span-1 lg:row-span-2 min-h-[280px]',
  },
  tone: {
    dark: 'bg-brand-950 text-brand-100',
    nav: 'bg-brand-900 text-brand-100',
    teal: 'bg-brand-600 text-brand-100',
    ice: 'bg-brand-100 text-brand-950',
    neutral: 'bg-neutral-50 text-brand-950',
  },
  image: 'absolute inset-0 h-full w-full object-cover opacity-30',
  content: 'relative z-10 flex flex-col gap-1',
  title: 'font-heading text-heading-sm sm:text-heading-md',
  description: 'font-sans text-sm opacity-90 line-clamp-2',
  cta: 'mt-2 font-sans text-sm font-medium underline-offset-2 group-hover:underline',
} as const;
